<template>
  <div>
    <PageAllow controller="Settings" action="miniprogramSetting" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="page-card transparent-background-color">
        <v-card>
          <v-card-title>
            {{ $t("MiniProgramSettings.ObjectName") }}
          </v-card-title>
          <v-divider />
          <v-card-text class="mt-8 pb-12">
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("MiniProgramSettings.Fields.home_template") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-select
                  v-model="template_id"
                  :items="homeTemplates"
                  item-text="text"
                  item-value="value"
                  unclearable
                ></v-select>
              </v-col>
            </v-row>
            <!-- 模板三 - 主题图 -->
            <v-row align="center" v-if="template.value == 3">
              <v-col cols="12">
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("MiniProgramSettings.Fields.theme_img") +
                      $t("Global.colon")
                    }}
                    <br />
                    <span class="subtitle-2">
                      {{ $t("MiniProgramSettings.Fields.theme_img_hint") }}
                    </span>
                  </v-col>
                  <v-col cols="9" md="7">
                    <v-card v-if="theme_img" max-width="140">
                      <v-img
                        :src="theme_img"
                        @click.stop="$showFullscreenImages([theme_img])"
                      >
                        <v-tooltip right v-if="theme_img">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              color="secondary"
                              class="pa-2 float-right"
                              @click.stop="
                                !theme_img.startsWith('data:image/') &&
                                theme_img == templateThreeSettings.theme_img_url
                                  ? (templateThreeSettings.theme_img_url =
                                      theme_img =
                                        null)
                                  : (theme_img = null)
                              "
                            >
                              fa-times
                            </v-icon>
                          </template>
                          <span>
                            {{
                              $t("BusinessSetting.AppAndWxApp.clear_image")
                            }}</span
                          >
                        </v-tooltip>
                      </v-img>
                    </v-card>
                    <v-file-input
                      ref="theme_img_file"
                      show-size
                      prepend-icon="fa-camera"
                      accept="image/png, image/jpeg"
                      persistent-hint
                      :placeholder="
                        $t('BusinessSetting.AppAndWxApp.imgPlaceholder')
                      "
                      :hint="
                        $t('BusinessSetting.AppAndWxApp.imgHint', [
                          '1200',
                          '600',
                        ]) +
                        $t('Global.semicolon') +
                        $t('BusinessSetting.AppAndWxApp.imgTips', ['400'])
                      "
                      :rules="imgRules"
                      v-model="theme_img_file"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <!-- 是否启用常购 -->
            <v-row align="center" v-if="template_id != 3">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("MiniProgramSettings.Fields.often_order") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-switch
                  v-model="setting.order_for_collect"
                  :label="
                    setting.order_for_collect
                      ? $t('MiniProgramSettings.oftenOrder.on')
                      : $t('MiniProgramSettings.oftenOrder.off')
                  "
                ></v-switch>
              </v-col>
            </v-row>
            <!-- 是否刷新为当前商品展示分类 -->
            <v-row
              align="center"
              v-if="
                this.template_id == 4 &&
                $permission.permissionAllow('Settings', 'miniprogramSetting') &&
                showCategories
              "
            >
              <v-col cols="7" sm="7" md="5" class="font-weight-bold text-right">
                {{
                  $t("MiniProgramSettings.Fields.refresh_material_categories") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="5" sm="5" md="7">
                <v-btn
                  color="primary"
                  @click.stop="
                    syncMaterialShowCategories();
                    showCategories = false;
                  "
                >
                  {{ $t("MiniProgramSettings.oftenOrder.start") }}
                </v-btn>
              </v-col>
            </v-row>
            <!-- 是否启用城市 -->
            <v-row align="center" v-if="template_id == 3">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("MiniProgramSettings.Fields.city_enable") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-radio-group row v-model="setting.city_enable">
                  <v-radio
                    :label="$t('BusinessSetting.RadioField.on')"
                    :key="1"
                    :value="1"
                  />
                  <v-radio
                    :label="$t('BusinessSetting.RadioField.off')"
                    :key="0"
                    :value="0"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row align="center" v-if="template_id == 3">
              <v-col cols="3" class="font-weight-bold text-right"> </v-col>
              <v-col cols="9" md="7">
                <v-row v-for="(city, index) in city_template_id" :key="index">
                  <v-col cols="5" md="5">
                    <v-text-field
                      v-model="city.city_name"
                      dense
                      :label="$t('MiniProgramSettings.Fields.city')"
                      single-line
                    />
                  </v-col>
                  <v-col cols="5" md="5">
                    <SearcherTemplate
                      v-model="city.template"
                      unclearable
                      no-label
                      dense
                    />
                  </v-col>
                  <v-col cols="2" md="2">
                    <v-btn
                      small
                      color="primary"
                      class="ms-1"
                      @click.stop="addCity()"
                      v-if="index == city_template_id.length - 1"
                    >
                      <v-icon x-small class="pe-1">fa-plus</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <!-- 微信客服 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("MiniProgramSettings.Fields.wechat_customer_service") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-row>
                  <v-text-field
                    v-model="setting.wechat_customer_service"
                    single-line
                  >
                  </v-text-field>
                </v-row>
              </v-col>
            </v-row>
            <!-- 企业ID -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("MiniProgramSettings.Fields.wechat_enterprise_id") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-row>
                  <v-text-field
                    v-model="setting.wechat_enterprise_id"
                    single-line
                  >
                  </v-text-field>
                </v-row>
              </v-col>
            </v-row>
            <!-- 是否隐藏注册 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("MiniProgramSettings.Fields.is_hidden_regiest") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-radio-group row v-model="setting.is_hidden_regiest">
                  <v-radio
                    :label="$t('BusinessSetting.RadioField.on')"
                    :key="1"
                    :value="1"
                  />
                  <v-radio
                    :label="$t('BusinessSetting.RadioField.off')"
                    :key="0"
                    :value="0"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
            <!-- 是否显示今日下单数 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("MiniProgramSettings.Fields.show_today_order_count") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-radio-group row v-model="setting.show_today_order_count">
                  <v-radio
                    :label="$t('BusinessSetting.RadioField.on')"
                    :key="1"
                    :value="1"
                  />
                  <v-radio
                    :label="$t('BusinessSetting.RadioField.off')"
                    :key="0"
                    :value="0"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
            <!-- 今日下单数刷新时间 -->
            <v-row align="center" v-if="setting.show_today_order_count">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("MiniProgramSettings.Fields.today_order_count_time_from") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-select
                  v-model="setting.today_order_count_time_from"
                  :items="timeOptions"
                  item-text="text"
                  item-value="value"
                  unclearable
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="my-5">
          <v-card-title>
            {{
              template
                ? template.text
                : $t("MiniProgramSettings.homeTemplates.template_four")
            }}
          </v-card-title>
          <v-divider />
          <v-card-text class="mt-8 pb-12">
            <ValidationObserver ref="observer">
              <!-- 是否显示公告 -->
              <v-row align="center" v-if="template.value == 4">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MiniProgramSettings.Fields.announcement_display") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-switch
                    v-model="setting.show_announcement_4"
                    :label="
                      setting.show_announcement_4
                        ? $t('MiniProgramSettings.oftenOrder.on')
                        : $t('MiniProgramSettings.oftenOrder.off')
                    "
                  ></v-switch>
                </v-col>
              </v-row>
              <!-- 是否显示使用说明 -->
              <v-row align="center" v-if="template.value == 4">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t(
                      "MiniProgramSettings.Fields.operation_instruction_display"
                    ) + $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-switch
                    v-model="setting.show_explanation_4"
                    :label="
                      setting.show_explanation_4
                        ? $t('MiniProgramSettings.oftenOrder.on')
                        : $t('MiniProgramSettings.oftenOrder.off')
                    "
                  ></v-switch>
                </v-col>
              </v-row>
              <!-- 是否显示要货规则 -->
              <v-row align="center" v-if="template.value == 4">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MiniProgramSettings.Fields.order_rule_display") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-switch
                    v-model="setting.show_rule_4"
                    :label="
                      setting.show_rule_4
                        ? $t('MiniProgramSettings.oftenOrder.on')
                        : $t('MiniProgramSettings.oftenOrder.off')
                    "
                  ></v-switch>
                </v-col>
              </v-row>
              <!-- 热门商品模块 -->
              <v-row
                align="center"
                v-if="template.value == 1 || template.value == 4"
              >
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MiniProgramSettings.Fields.hot_material_display") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-switch
                    v-model="setting.open_hot_block_4"
                    :label="
                      setting.open_hot_block_4
                        ? $t('MiniProgramSettings.oftenOrder.on')
                        : $t('MiniProgramSettings.oftenOrder.off')
                    "
                  ></v-switch>
                </v-col>
              </v-row>
              <!-- 分享注册 -->
              <v-row align="center" v-if="template.value == 4">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MiniProgramSettings.Fields.share_register_display") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-switch
                    v-model="setting.share_register_4"
                    :label="
                      setting.share_register_4
                        ? $t('MiniProgramSettings.oftenOrder.on')
                        : $t('MiniProgramSettings.oftenOrder.off')
                    "
                  ></v-switch>
                </v-col>
              </v-row>
              <!-- 热门商品模块标题 -->
              <v-row align="center" v-if="template.value == 1">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MiniProgramSettings.Fields.hot_material_title") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-text-field
                    v-model="setting.hot_block_title_1"
                    single-line
                    dense
                  />
                </v-col>
              </v-row>
              <v-row align="center" v-if="template.value == 4">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MiniProgramSettings.Fields.hot_material_title") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-text-field
                    v-model="setting.hot_block_title_4"
                    single-line
                    dense
                  />
                </v-col>
              </v-row>
              <!-- 热门商品 -->
              <v-row v-if="template.value == 1 || template.value == 4">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MiniProgramSettings.Fields.hot_material_select") +
                    $t("Global.colon")
                  }}
                  <br />
                  <v-btn
                    color="primary"
                    class="my-1 mr-3"
                    x-small
                    outlined
                    @click.stop="selectMaterialsDialog = true"
                  >
                    {{
                      $t("CRUD.chooseInfo", [
                        $t("MiniProgramSettings.Fields.material"),
                      ])
                    }}
                  </v-btn>
                </v-col>
                <v-col cols="9" md="7">
                  <v-data-table
                    :headers="header"
                    :items="materialItems"
                    :loading="loading"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        v-if="template.value == 1"
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          materials.splice(
                            materials.findIndex(
                              (material) => material.id == item.id
                            ),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="template.value == 4"
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          materials_4.splice(
                            materials_4.findIndex(
                              (material) => material.id == item.id
                            ),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <!-- 热门菜品模块标题 -->
              <v-row
                align="center"
                v-if="
                  (template.value == 4 || template.value == 3) &&
                  settings &&
                  settings.food_order_enable
                "
              >
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MiniProgramSettings.Fields.hot_food_title") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-text-field
                    v-if="template.value == 4"
                    v-model="setting.hot_food_title_4"
                    single-line
                    dense
                  />
                  <v-text-field
                    v-if="template.value == 3"
                    v-model="setting.hot_food_title_3"
                    single-line
                    dense
                  />
                </v-col>
              </v-row>
              <!-- 热门菜品 -->
              <v-row
                v-if="
                  (template.value == 4 || template.value == 3) &&
                  settings &&
                  settings.food_order_enable
                "
              >
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MiniProgramSettings.Fields.hot_food_select") +
                    $t("Global.colon")
                  }}
                  <br />
                  <v-btn
                    color="primary"
                    class="my-1 mr-3"
                    x-small
                    outlined
                    @click.stop="selectFoodsDialog = true"
                  >
                    {{
                      $t("CRUD.chooseInfo", [
                        $t("MiniProgramSettings.Fields.food"),
                      ])
                    }}
                  </v-btn>
                </v-col>
                <v-col cols="9" md="7" v-if="template.value == 3">
                  <v-data-table
                    :headers="foodHeader"
                    :items="foods_3"
                    :loading="loading"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>
                    <template v-slot:item.food="{ item }">
                      {{
                        $t("MiniProgramSettings.Fields.food_description", [
                          item.food.food_code,
                          item.food.food_name,
                        ])
                      }}
                    </template>
                    <template v-slot:item.food_relations="{ item }">
                      {{
                        $t(
                          "MiniProgramSettings.Fields.food_relations_description",
                          [
                            item.food_formula.formula_name,
                            item.food_behavior.behavior_name,
                          ]
                        )
                      }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        v-if="template.value == 3"
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          foods_3.splice(
                            foods_3.findIndex(
                              (material) => material.id == item.id
                            ),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
                <v-col cols="9" md="7" v-if="template.value == 4">
                  <v-data-table
                    :headers="foodHeader"
                    :items="foods_4"
                    :loading="loading"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>
                    <template v-slot:item.food="{ item }">
                      {{
                        $t("MiniProgramSettings.Fields.food_description", [
                          item.food.food_code,
                          item.food.food_name,
                        ])
                      }}
                    </template>
                    <template v-slot:item.food_relations="{ item }">
                      {{
                        $t(
                          "MiniProgramSettings.Fields.food_relations_description",
                          [
                            item.food_formula.formula_name,
                            item.food_behavior.behavior_name,
                          ]
                        )
                      }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        v-if="template.value == 4"
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          foods_4.splice(
                            foods_4.findIndex(
                              (material) => material.id == item.id
                            ),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <!-- 精选专题模块 -->
              <v-row align="center" v-if="template.value == 1">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MiniProgramSettings.Fields.selected_topics") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-switch
                    v-model="setting.open_topics_block_1"
                    :label="
                      setting.open_topics_block_1
                        ? $t('MiniProgramSettings.oftenOrder.on')
                        : $t('MiniProgramSettings.oftenOrder.off')
                    "
                  ></v-switch>
                </v-col>
              </v-row>
              <!-- 畅销商品 -->
              <v-row align="center" v-if="template.value == 1">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MiniProgramSettings.Fields.best_seller_materials") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-switch
                    v-model="setting.open_best_sale_block_1"
                    :label="
                      setting.open_best_sale_block_1
                        ? $t('MiniProgramSettings.oftenOrder.on')
                        : $t('MiniProgramSettings.oftenOrder.off')
                    "
                  ></v-switch>
                </v-col>
              </v-row>
              <!-- 分类模块 -->
              <v-row align="center" v-if="template.value == 2">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MiniProgramSettings.Fields.categories_module") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-switch
                    v-model="setting.open_category_block_2"
                    :label="
                      setting.open_category_block_2
                        ? $t('MiniProgramSettings.oftenOrder.on')
                        : $t('MiniProgramSettings.oftenOrder.off')
                    "
                  ></v-switch>
                </v-col>
              </v-row>
              <!-- 首页专题模块 -->
              <v-row align="center" v-if="template.value == 3">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MiniProgramSettings.Fields.special_enable") +
                    $t("Global.colon")
                  }}
                  <br />
                  <span class="subtitle-2">
                    {{ $t("MiniProgramSettings.Fields.specialHint") }}
                  </span>
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="setting.special_enable">
                    <v-radio
                      :label="$t('BusinessSetting.RadioField.on')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('BusinessSetting.RadioField.off')"
                      :key="0"
                      :value="0"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row align="center" v-if="template.value == 3">
                <v-col
                  cols="12"
                  v-for="(special, index) in special_list"
                  :key="index"
                >
                  <!-- 专题 -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        (index == 0
                          ? $t("MiniProgramSettings.Fields.title_one")
                          : index == 1
                          ? $t("MiniProgramSettings.Fields.title_two")
                          : index == 2
                          ? $t("MiniProgramSettings.Fields.title_three")
                          : $t("MiniProgramSettings.Fields.title_four")) +
                        $t("Global.colon")
                      }}
                      <span class="red--text">*</span>
                    </v-col>
                    <v-col cols="7" md="7">
                      <ValidationProvider
                        v-slot="{ errors }"
                        :name="
                          index == 0
                            ? $t('MiniProgramSettings.Fields.title_one')
                            : index == 1
                            ? $t('MiniProgramSettings.Fields.title_two')
                            : index == 2
                            ? $t('MiniProgramSettings.Fields.title_three')
                            : $t('MiniProgramSettings.Fields.title_four')
                        "
                        rules="required"
                      >
                        <v-text-field
                          v-model="special.title"
                          dense
                          :label="$t('MiniProgramSettings.Fields.special')"
                          single-line
                          :error-messages="errors"
                        />
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="2" md="2">
                      <v-btn
                        small
                        color="primary"
                        class="ms-1"
                        @click.stop="addSpecial()"
                        v-if="
                          index == special_list.length - 1 &&
                          special_list.length < 4
                        "
                      >
                        <v-icon x-small class="pe-1">fa-plus</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <!-- 专题logo -->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        (index == 0
                          ? $t("MiniProgramSettings.Fields.logo_one")
                          : index == 1
                          ? $t("MiniProgramSettings.Fields.logo_two")
                          : index == 2
                          ? $t("MiniProgramSettings.Fields.logo_three")
                          : $t("MiniProgramSettings.Fields.logo_four")) +
                        $t("Global.colon")
                      }}
                      <span class="red--text">*</span>
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-card v-if="special.log_image" max-width="140">
                        <v-img
                          :src="special.log_image"
                          @click.stop="
                            $showFullscreenImages([special.log_image])
                          "
                        >
                          <v-tooltip right v-if="special.log_image">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                color="secondary"
                                class="pa-2 float-right"
                                @click.stop="
                                  !special.log_image.startsWith(
                                    'data:image/'
                                  ) && special.log_image == special.logo_url
                                    ? (special.log_image =
                                        special.logo_url =
                                        special.logo =
                                          null)
                                    : (special.log_image = null);
                                  special.log_image_file = null;
                                "
                              >
                                fa-times
                              </v-icon>
                            </template>
                            <span>
                              {{
                                $t("BusinessSetting.AppAndWxApp.clear_image")
                              }}</span
                            >
                          </v-tooltip>
                        </v-img>
                      </v-card>
                      <v-file-input
                        ref="log_image_file"
                        show-size
                        prepend-icon="fa-camera"
                        accept="image/png, image/jpeg"
                        persistent-hint
                        :placeholder="
                          $t('BusinessSetting.AppAndWxApp.imgPlaceholder')
                        "
                        :hint="
                          $t('BusinessSetting.AppAndWxApp.imgHint', [
                            '1200',
                            '600',
                          ])
                        "
                        :rules="imgRules"
                        v-model="special.log_image_file"
                      />
                    </v-col>
                  </v-row>
                  <!-- 专题商品-->
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        (index == 0
                          ? $t("MiniProgramSettings.Fields.production_one")
                          : index == 1
                          ? $t("MiniProgramSettings.Fields.production_two")
                          : index == 2
                          ? $t("MiniProgramSettings.Fields.production_three")
                          : $t("MiniProgramSettings.Fields.production_four")) +
                        $t("Global.colon")
                      }}
                      <span class="red--text">*</span>
                      <br />
                      <v-btn
                        color="primary"
                        class="my-1 mr-3"
                        x-small
                        outlined
                        @click.stop="
                          selectProductionsDialog = true;
                          specialListIndex = index;
                        "
                      >
                        {{
                          $t("CRUD.chooseInfo", [
                            $t("MiniProgramSettings.Fields.material"),
                          ])
                        }}
                      </v-btn>
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-data-table
                        :headers="header"
                        :items="special.production"
                        :loading="loading"
                        multi-sort
                        class="elevation-1 px-4 pt-2"
                        disable-pagination
                        hide-default-footer
                      >
                        <template v-slot:header.actions="{ header }">
                          {{ header.text }}
                          <v-icon x-small>fa-sliders-h</v-icon>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            small
                            text
                            class="danger--text pa-0"
                            @click="
                              special.production.splice(
                                special.production.findIndex(
                                  (material) => material.id == item.id
                                ),
                                1
                              )
                            "
                          >
                            <v-icon>fa-times</v-icon>
                          </v-btn>
                        </template>
                        <template v-slot:item.Description="{ item }">
                          {{
                            $t(
                              settings
                                ? settings.material_name_display_type == 4
                                  ? "Material.nameWithCodeAndStandard"
                                  : settings.material_name_display_type == 3
                                  ? "Material.materialNameWithCodeAndStandard"
                                  : settings.material_name_display_type == 2
                                  ? "Material.materialNameWithCode"
                                  : "Material.materialName"
                                : "Material.materialName",
                              [
                                item.material_code,
                                item.material_name,
                                item.standard_name,
                              ]
                            )
                          }}
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- 首页公告 -->
              <v-row align="center" v-if="template_id == 3">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MiniProgramSettings.Fields.announcement_enable") +
                    $t("Global.colon")
                  }}
                  <br />
                  <span class="subtitle-2">
                    {{ $t("MiniProgramSettings.Fields.announcementHint") }}
                  </span>
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="setting.announcement_enable">
                    <v-radio
                      :label="$t('BusinessSetting.RadioField.on')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('BusinessSetting.RadioField.off')"
                      :key="0"
                      :value="0"
                    />
                    <span class="subtitle-2">
                      {{ $t("MiniProgramSettings.Fields.announcementHintTwo") }}
                    </span>
                  </v-radio-group>
                </v-col>
              </v-row>
              <!-- 首页轮播推广 -->
              <v-row align="center" v-if="template_id == 3">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MiniProgramSettings.Fields.material_banner_enable") +
                    $t("Global.colon")
                  }}
                  <br />
                  <span class="subtitle-2">
                    {{ $t("MiniProgramSettings.Fields.material_banner_hint") }}
                  </span>
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="setting.material_banner_enable">
                    <v-radio
                      :label="$t('BusinessSetting.RadioField.on')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('BusinessSetting.RadioField.off')"
                      :key="0"
                      :value="0"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row
                align="center"
                v-if="template_id == 3 && setting.material_banner_enable"
              >
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MiniProgramSettings.Fields.material_banner_list") +
                    $t("Global.colon")
                  }}<span class="red--text">*</span>
                  <br />
                  <v-btn
                    v-if="bannerMaterial.length < 10"
                    color="primary"
                    class="my-1 mr-3"
                    x-small
                    outlined
                    @click.stop="selectBannerMaterialsDialog = true"
                  >
                    {{
                      $t("CRUD.chooseInfo", [
                        $t("MiniProgramSettings.Fields.material"),
                      ])
                    }}
                  </v-btn>
                </v-col>
                <v-col cols="9" md="7">
                  <v-data-table
                    :headers="headers"
                    :items="bannerMaterial"
                    :loading="loading"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          bannerMaterial.splice(
                            bannerMaterial.findIndex(
                              (material) => material.id == item.id
                            ),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                    <template v-slot:item.Description="{ item }">
                      {{
                        $t(
                          settings
                            ? settings.material_name_display_type == 4
                              ? "Material.nameWithCodeAndStandard"
                              : settings.material_name_display_type == 3
                              ? "Material.materialNameWithCodeAndStandard"
                              : settings.material_name_display_type == 2
                              ? "Material.materialNameWithCode"
                              : "Material.materialName"
                            : "Material.materialName",
                          [
                            item.material_code,
                            item.material_name,
                            item.standard_name,
                          ]
                        )
                      }}
                    </template>
                    <template v-slot:item.banner_img="{ item }">
                      <v-card v-if="item.banner_img" max-width="140">
                        <v-img
                          :src="item.banner_img"
                          @click.stop="$showFullscreenImages([item.banner_img])"
                        >
                          <v-tooltip right v-if="item.banner_img">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                color="secondary"
                                class="pa-2 float-right"
                                @click.stop="
                                  !item.banner_img.startsWith('data:image/') &&
                                  item.banner_img == item.img_rul
                                    ? (item.img_rul =
                                        item.banner_img =
                                        item.img =
                                          null)
                                    : (item.banner_img = null);
                                  item.banner_img_file = null;
                                "
                              >
                                fa-times
                              </v-icon>
                            </template>
                            <span>
                              {{
                                $t("BusinessSetting.AppAndWxApp.clear_image")
                              }}</span
                            >
                          </v-tooltip>
                        </v-img>
                      </v-card>
                      <v-file-input
                        ref="banner_img_file"
                        show-size
                        prepend-icon="fa-camera"
                        accept="image/png, image/jpeg"
                        persistent-hint
                        :placeholder="
                          $t('BusinessSetting.AppAndWxApp.imgPlaceholder')
                        "
                        :hint="
                          $t('BusinessSetting.AppAndWxApp.imgHint', [
                            '1200',
                            '400',
                          ])
                        "
                        :rules="imgRules"
                        v-model="item.banner_img_file"
                      />
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <!-- 首页热门商品 -->
              <v-row v-show="false" align="center" v-if="template.value == 3">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MiniProgramSettings.Fields.hot_material_enable") +
                    $t("Global.colon")
                  }}
                  <br />
                  <!-- <span class="subtitle-2">
                    {{ $t("MiniProgramSettings.Fields.specialHint") }}
                  </span> -->
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="setting.hot_material_enable">
                    <v-radio
                      :label="$t('BusinessSetting.RadioField.on')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('BusinessSetting.RadioField.off')"
                      :key="0"
                      :value="0"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row
                v-show="false"
                align="center"
                v-if="template.value == 3 && setting.hot_material_enable"
              >
                <v-col cols="12">
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("MiniProgramSettings.Fields.hot_title") +
                        $t("Global.colon")
                      }}<span class="red--text">*</span>
                    </v-col>
                    <v-col cols="7" md="7">
                      <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('MiniProgramSettings.Fields.hot_title')"
                        rules="required"
                      >
                        <v-text-field
                          v-model="setting.hot_material_title"
                          dense
                          type="text"
                          :label="$t('MiniProgramSettings.Fields.special')"
                          single-line
                          :error-messages="errors"
                        />
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("MiniProgramSettings.Fields.hot_material_img") +
                        $t("Global.colon")
                      }}<span class="red--text">*</span>
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-card v-if="hot_material_img" max-width="140">
                        <v-img
                          :src="hot_material_img"
                          @click.stop="
                            $showFullscreenImages([hot_material_img])
                          "
                        >
                          <v-tooltip right v-if="hot_material_img">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                color="secondary"
                                class="pa-2 float-right"
                                @click.stop="
                                  !hot_material_img.startsWith('data:image/') &&
                                  hot_material_img ==
                                    templateThreeSettings.hot_material_img_url
                                    ? (templateThreeSettings.hot_material_img_url =
                                        hot_material_img =
                                          null)
                                    : (hot_material_img = null)
                                "
                              >
                                fa-times
                              </v-icon>
                            </template>
                            <span>
                              {{
                                $t("BusinessSetting.AppAndWxApp.clear_image")
                              }}</span
                            >
                          </v-tooltip>
                        </v-img>
                      </v-card>
                      <v-file-input
                        ref="hot_material_img_file"
                        show-size
                        prepend-icon="fa-camera"
                        accept="image/png, image/jpeg"
                        persistent-hint
                        :placeholder="
                          $t('BusinessSetting.AppAndWxApp.imgPlaceholder')
                        "
                        :hint="
                          $t('BusinessSetting.AppAndWxApp.imgHint', [
                            '1200',
                            '600',
                          ])
                        "
                        :rules="imgRules"
                        v-model="hot_material_img_file"
                      />
                    </v-col>
                  </v-row>
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("MiniProgramSettings.Fields.hot_material_list") +
                        $t("Global.colon")
                      }}<span class="red--text">*</span>
                      <br />
                      <v-btn
                        v-if="hotMaterial.length < 20"
                        color="primary"
                        class="my-1 mr-3"
                        x-small
                        outlined
                        @click.stop="selecthotMaterialsDialog = true"
                      >
                        {{
                          $t("CRUD.chooseInfo", [
                            $t("MiniProgramSettings.Fields.material"),
                          ])
                        }}
                      </v-btn>
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-data-table
                        :headers="header"
                        :items="hotMaterial"
                        :loading="loading"
                        multi-sort
                        class="elevation-1 px-4 pt-2"
                        disable-pagination
                        hide-default-footer
                      >
                        <template v-slot:header.actions="{ header }">
                          {{ header.text }}
                          <v-icon x-small>fa-sliders-h</v-icon>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            small
                            text
                            class="danger--text pa-0"
                            @click="
                              hotMaterial.splice(
                                hotMaterial.findIndex(
                                  (material) => material.id == item.id
                                ),
                                1
                              )
                            "
                          >
                            <v-icon>fa-times</v-icon>
                          </v-btn>
                        </template>
                        <template v-slot:item.Description="{ item }">
                          {{
                            $t(
                              settings
                                ? settings.material_name_display_type == 4
                                  ? "Material.nameWithCodeAndStandard"
                                  : settings.material_name_display_type == 3
                                  ? "Material.materialNameWithCodeAndStandard"
                                  : settings.material_name_display_type == 2
                                  ? "Material.materialNameWithCode"
                                  : "Material.materialName"
                                : "Material.materialName",
                              [
                                item.material_code,
                                item.material_name,
                                item.standard_name,
                              ]
                            )
                          }}
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- 首页热门分类 -->
              <v-row align="center" v-if="template.value == 3">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MiniProgramSettings.Fields.hot_category_enable") +
                    $t("Global.colon")
                  }}
                  <br />
                  <span class="subtitle-2">
                    {{ $t("MiniProgramSettings.Fields.hot_category_hint") }}
                  </span>
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="setting.hot_category_enable">
                    <v-radio
                      :label="$t('BusinessSetting.RadioField.on')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('BusinessSetting.RadioField.off')"
                      :key="0"
                      :value="0"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row
                align="center"
                v-if="template.value == 3 && setting.hot_category_enable"
              >
                <v-col cols="12">
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("MiniProgramSettings.Fields.hot_category_list") +
                        $t("Global.colon")
                      }}<span class="red--text">*</span>
                      <br />
                      <v-btn
                        color="primary"
                        class="my-1 mr-3"
                        x-small
                        outlined
                        @click.stop="selecthotCategoriesDialog = true"
                      >
                        {{
                          $t("CRUD.chooseInfo", [
                            $t("MiniProgramSettings.Fields.hot_category_btn"),
                          ])
                        }}
                      </v-btn>
                      <br />
                      <span class="subtitle-2">
                        {{ $t("MiniProgramSettings.Fields.categoryImgHint") }}
                      </span>
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-data-table
                        :headers="categoryHeader"
                        :items="hotCategories"
                        :loading="loading"
                        multi-sort
                        class="elevation-1 px-4 pt-2"
                        disable-pagination
                        hide-default-footer
                      >
                        <template v-slot:header.actions="{ header }">
                          {{ header.text }}
                          <v-icon x-small>fa-sliders-h</v-icon>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            small
                            text
                            class="danger--text pa-0"
                            @click="
                              hotCategories.splice(
                                hotCategories.findIndex(
                                  (category) => category.id == item.id
                                ),
                                1
                              )
                            "
                          >
                            <v-icon>fa-times</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- 首页温馨提示图 -->
              <v-row align="center" v-if="template.value == 3">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MiniProgramSettings.Fields.notify_img_enable") +
                    $t("Global.colon")
                  }}
                  <br />
                  <span class="subtitle-2">
                    {{ $t("MiniProgramSettings.Fields.notify_img_hint") }}
                  </span>
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="setting.notify_img_enable">
                    <v-radio
                      :label="$t('BusinessSetting.RadioField.on')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('BusinessSetting.RadioField.off')"
                      :key="0"
                      :value="0"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row
                align="center"
                v-if="template.value == 3 && setting.notify_img_enable"
              >
                <v-col cols="12">
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("MiniProgramSettings.Fields.notify_img") +
                        $t("Global.colon")
                      }}<span class="red--text">*</span>
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-card v-if="notify_img" max-width="140">
                        <v-img
                          :src="notify_img"
                          @click.stop="$showFullscreenImages([notify_img])"
                        >
                          <v-tooltip right v-if="notify_img">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                color="secondary"
                                class="pa-2 float-right"
                                @click.stop="
                                  !notify_img.startsWith('data:image/') &&
                                  notify_img ==
                                    templateThreeSettings.notify_img_url
                                    ? (templateThreeSettings.notify_img_url =
                                        notify_img =
                                          null)
                                    : (notify_img = null)
                                "
                              >
                                fa-times
                              </v-icon>
                            </template>
                            <span>
                              {{
                                $t("BusinessSetting.AppAndWxApp.clear_image")
                              }}</span
                            >
                          </v-tooltip>
                        </v-img>
                      </v-card>
                      <v-file-input
                        ref="notify_img_file"
                        show-size
                        prepend-icon="fa-camera"
                        accept="image/png, image/jpeg"
                        persistent-hint
                        :placeholder="
                          $t('BusinessSetting.AppAndWxApp.imgPlaceholder')
                        "
                        :hint="$t('MiniProgramSettings.Fields.imgHint')"
                        :rules="imgRules"
                        v-model="notify_img_file"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- 首页推荐展示分类 -->
              <v-row align="center" v-if="template.value == 3">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MiniProgramSettings.Fields.home_category_enable") +
                    $t("Global.colon")
                  }}
                  <br />
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="home_category_enable">
                    <v-radio
                      :label="$t('BusinessSetting.RadioField.on')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('BusinessSetting.RadioField.off')"
                      :key="0"
                      :value="0"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row
                align="center"
                v-if="template.value == 3 && home_category_enable"
              >
                <v-col cols="12">
                  <v-row align="center">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("MiniProgramSettings.Fields.home_category_list") +
                        $t("Global.colon")
                      }}
                      <br />
                      <v-btn
                        color="primary"
                        class="my-1 mr-3"
                        x-small
                        outlined
                        @click.stop="selectHomeCategoriesDialog = true"
                      >
                        {{
                          $t("CRUD.chooseInfo", [
                            $t("MiniProgramSettings.Fields.hot_category_btn"),
                          ])
                        }}
                      </v-btn>
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-data-table
                        :headers="categoryHeader"
                        :items="homeCategories"
                        :loading="loading"
                        multi-sort
                        class="elevation-1 px-4 pt-2"
                        disable-pagination
                        hide-default-footer
                      >
                        <template v-slot:header.actions="{ header }">
                          {{ header.text }}
                          <v-icon x-small>fa-sliders-h</v-icon>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            small
                            text
                            class="danger--text pa-0"
                            @click="
                              homeCategories.splice(
                                homeCategories.findIndex(
                                  (category) => category.id == item.id
                                ),
                                1
                              )
                            "
                          >
                            <v-icon>fa-times</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </ValidationObserver>
          </v-card-text>
        </v-card>
      </v-sheet>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn color="success" block @click="save()">
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("CRUD.save") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>

    <MaterialsSelectsDialog
      v-if="template_id == 1"
      v-model="selectMaterialsDialog"
      :materialIds="materialIdsArr_1"
      :disabledChoosed="true"
      @confirm="addMaterials = $event"
    />
    <MaterialsSelectsDialog
      v-if="template_id == 4"
      v-model="selectMaterialsDialog"
      :materialIds="materialIdsArr_4"
      :disabledChoosed="true"
      @confirm="addMaterials = $event"
    />
    <MaterialsSelectsDialog
      v-model="selectBannerMaterialsDialog"
      :materialIds="bannerMaterialIdsArr"
      :disabledChoosed="true"
      @confirm="addBannerMaterials = $event"
    />
    <MaterialsSelectsDialog
      v-model="selecthotMaterialsDialog"
      :materialIds="hotMaterialIdsArr"
      :disabledChoosed="true"
      @confirm="addhotMaterials = $event"
    />
    <CategoriesSelectsDialog
      v-model="selecthotCategoriesDialog"
      :categoryIds="hotCategoryIdsArr"
      :disabledChoosed="true"
      @confirm="addhotCategories = $event"
    />
    <CategoriesSelectsDialog
      v-model="selectHomeCategoriesDialog"
      :categoryIds="homeCategoryIdsArr"
      :disabledChoosed="true"
      @confirm="addHomeCategories = $event"
    />
    <MaterialsSelectsDialog
      v-if="template_id == 3"
      v-model="selectProductionsDialog"
      :materialIds="
        specialListIndex == 0
          ? specialMaterialIdsArr_1
          : specialListIndex == 1
          ? specialMaterialIdsArr_2
          : specialListIndex == 2
          ? specialMaterialIdsArr_3
          : specialListIndex == 3
          ? specialMaterialIdsArr_4
          : []
      "
      :disabledChoosed="true"
      @confirm="addProductions = $event"
    />
    <FoodsSelectsDialog
      v-if="template_id == 4"
      v-model="selectFoodsDialog"
      :foodIds="foodIdsArr_4"
      @confirm="addFoods = $event"
    />
    <FoodsSelectsDialog
      v-if="template_id == 3"
      v-model="selectFoodsDialog"
      :foodIds="foodIdsArr_3"
      @confirm="addFoods = $event"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import MaterialsSelectsDialog from "@/components/plugins/MaterialsSelectsDialog";
import Settings from "@/api/settings";
import Materials from "@/api/materials";
import MaterialCategories from "@/api/material_categories";
import SearcherTemplate from "@/components/plugins/SearcherTemplate";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import CategoriesSelectsDialog from "./plugins/CategoriesSelectsDialog";
import Files from "@/api/files";
import MaterialShowCategories from "@/api/material_show_categories";
import FoodRelations from "@/api/food_relations";
import FoodsSelectsDialog from "@/components/plugins/FoodsSelectsDialog";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    MaterialsSelectsDialog,
    SearcherTemplate,
    ValidationObserver,
    ValidationProvider,
    CategoriesSelectsDialog,
    FoodsSelectsDialog,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("SettingNav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.settings"),
        disabled: false,
        href: "/settings/bussiness-settings",
      },
      {
        text: i18n.t("SettingNav.miniProgramSetting"),
        disabled: true,
        href: "/settings/mini-program-settings",
      },
    ],

    homeTemplates() {
      return [
        {
          text: i18n.t("MiniProgramSettings.homeTemplates.template_one"),
          value: 1,
        },
        {
          text: i18n.t("MiniProgramSettings.homeTemplates.template_two"),
          value: 2,
        },
        {
          text: i18n.t("MiniProgramSettings.homeTemplates.template_three"),
          value: 3,
        },
        {
          text: i18n.t("MiniProgramSettings.homeTemplates.template_four"),
          value: 4,
        },
      ];
    },

    timeOptions() {
      return Array.from({ length: 24 }, (_, i) => {
        const hour = i.toString().padStart(2, "0");
        return { text: `${hour}:00`, value: `${hour}:00` };
      });
    },

    header() {
      return [
        {
          text: i18n.t("MiniProgramSettings.Fields.material"),
          align: "start",
          sortable: false,
          value: "Description",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },
    foodHeader() {
      return [
        {
          text: i18n.t("MiniProgramSettings.Fields.food"),
          align: "start",
          sortable: false,
          value: "food",
        },
        {
          text: i18n.t("MiniProgramSettings.Fields.food_relations"),
          align: "start",
          sortable: false,
          value: "food_relations",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },
    headers() {
      return [
        {
          text: i18n.t("MiniProgramSettings.Fields.material"),
          align: "start",
          sortable: false,
          value: "Description",
        },
        // 图片
        {
          text: i18n.t("MiniProgramSettings.Fields.img"),
          align: "start",
          sortable: false,
          value: "banner_img",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },
    categoryHeader() {
      return [
        {
          text: i18n.t("MaterialShowCategory.Fields.show_category_name"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "name",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },

    materialItems() {
      var materials = [];
      if (this.template_id == 1) {
        materials = this.materials_1.map((detail) => {
          detail.Description = i18n.t(
            this.settings
              ? this.settings.material_name_display_type == 4
                ? "Material.nameWithCodeAndStandard"
                : this.settings.material_name_display_type == 3
                ? "Material.materialNameWithCodeAndStandard"
                : this.settings.material_name_display_type == 2
                ? "Material.materialNameWithCode"
                : "Material.materialName"
              : "Material.materialName",
            [detail.material_code, detail.material_name, detail.standard_name]
          );

          return detail;
        });
      } else if (this.template_id == 4) {
        materials = this.materials_4.map((detail) => {
          detail.Description = i18n.t(
            this.settings
              ? this.settings.material_name_display_type == 4
                ? "Material.nameWithCodeAndStandard"
                : this.settings.material_name_display_type == 3
                ? "Material.materialNameWithCodeAndStandard"
                : this.settings.material_name_display_type == 2
                ? "Material.materialNameWithCode"
                : "Material.materialName"
              : "Material.materialName",
            [detail.material_code, detail.material_name, detail.standard_name]
          );

          return detail;
        });
      }

      return materials;
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "accountInfo"]),
  },

  data: () => ({
    setting: {},
    template: {},
    materials_1: [],
    materialIdsArr_1: [],
    materials_4: [],
    materialIdsArr_4: [],
    selectMaterialsDialog: false,
    addMaterials: [],
    showCategories: true,
    city_template_id: [{}],
    special_list: [{ log_image: null, log_image_file: null, production: [] }],
    imgRules: [
      (value) => !value || value.size < 5000000 || i18n.t("Material.imgHint"),
    ],
    specialListIndex: null,
    selectProductionsDialog: false,
    addProductions: [],
    specialMaterialIdsArr_1: [],
    specialMaterialIdsArr_2: [],
    specialMaterialIdsArr_3: [],
    specialMaterialIdsArr_4: [],
    selectBannerMaterialsDialog: false,
    addBannerMaterials: [],
    bannerMaterialIdsArr: [],
    bannerMaterial: [],
    hotMaterial: [],
    selecthotMaterialsDialog: false,
    hotMaterialIdsArr: [],
    addhotMaterials: [],
    selecthotCategoriesDialog: false,
    selectHomeCategoriesDialog: false,
    hotCategoryIdsArr: [],
    homeCategoryIdsArr: [],
    addhotCategories: [],
    addHomeCategories: [],
    hotCategories: [],
    homeCategories: [],
    hot_material_img: "",
    hot_material_img_file: null,
    notify_img: "",
    notify_img_file: null,
    theme_img: "",
    theme_img_file: null,
    template_id: null,
    templateThreeSettings: {},
    home_category_enable: 0,
    selectFoodsDialog: false,
    foods_4: [],
    foods_3: [],
    foodIdsArr_4: [],
    foodIdsArr_3: [],
    addFoods: [],
  }),

  mounted() {
    this.getSettingsFromAPI();
  },

  methods: {
    getSettingsFromAPI() {
      Settings.fetch({
        keys: ["miniprogram"],
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.settings.miniprogram) {
              this.setting = JSON.parse(
                JSON.stringify(response.data.settings.miniprogram)
              );
              if (this.setting.template_id == 3) {
                Settings.getWechatTemplateThreeSettings().then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.templateThreeSettings = response.data.settings;
                    }
                  }.bind(this)
                );
                // this.getTemplateThreeSettings();
              }
              this.template_id = this.setting.template_id;
              for (let setting_key in this.setting) {
                if (
                  setting_key == "hot_block_title_1" ||
                  setting_key == "hot_product_list_1" ||
                  setting_key == "hot_block_title_4" ||
                  setting_key == "hot_food_title_4" ||
                  setting_key == "hot_food_title_3" ||
                  setting_key == "hot_product_list_4" ||
                  setting_key == "hot_food_list_4" ||
                  setting_key == "hot_food_list_3" ||
                  setting_key == "hot_material_title" ||
                  setting_key == "city_template_id" ||
                  setting_key == "special_list" ||
                  setting_key == "material_banner_list" ||
                  setting_key == "hot_material_list" ||
                  setting_key == "hot_category_list" ||
                  setting_key == "notify_img_url" ||
                  setting_key == "theme_img_url" ||
                  setting_key == "hot_material_img_url" ||
                  setting_key == "wechat_customer_service" ||
                  setting_key == "wechat_enterprise_id" ||
                  setting_key == "is_hidden_regiest" ||
                  setting_key == "show_today_order_count" ||
                  setting_key == "today_order_count_time_from"
                ) {
                  continue;
                } else if (
                  typeof this.setting[setting_key] == "string" &&
                  this.setting[setting_key].length > 0
                ) {
                  this.setting[setting_key] = Number(this.setting[setting_key]);
                } else if (
                  typeof this.setting[setting_key] == "string" &&
                  this.setting[setting_key].length == 0
                ) {
                  this.setting[setting_key] = 0;
                }
              }
              //查询商品
              if (
                this.template_id == 4 &&
                this.setting.hot_product_list_4 &&
                this.setting.hot_product_list_4.length
              ) {
                Materials.fetch({
                  material_ids: this.setting.hot_product_list_4,
                }).then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.materials_4 = response.data.materials;
                    }
                  }.bind(this)
                );
              } else if (
                this.template_id == 1 &&
                this.setting.hot_product_list_1 &&
                this.setting.hot_product_list_1.length
              ) {
                Materials.fetch({
                  material_ids: this.setting.hot_product_list_1,
                }).then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.materials_1 = response.data.materials;
                    }
                  }.bind(this)
                );
              }
              //查询菜品
              if (
                this.template_id == 4 &&
                this.setting.hot_food_list_4 &&
                this.setting.hot_food_list_4.length
              ) {
                FoodRelations.fetch({
                  food_relation_ids: this.setting.hot_food_list_4,
                }).then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.foods_4 = response.data.food_relations;
                    }
                  }.bind(this)
                );
              }
              if (
                this.template_id == 3 &&
                this.setting.hot_food_list_3 &&
                this.setting.hot_food_list_3.length
              ) {
                FoodRelations.fetch({
                  food_relation_ids: this.setting.hot_food_list_3,
                }).then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.foods_3 = response.data.food_relations;
                    }
                  }.bind(this)
                );
              }
              if ( 
                this.setting.is_hidden_regiest == null ||
                typeof this.setting.is_hidden_regiest == "undefined" ||
                this.setting.is_hidden_regiest == undefined
              ) {
                this.setting.is_hidden_regiest = 0;
              }
              if ( 
                this.setting.show_today_order_count == null ||
                typeof this.setting.show_today_order_count == "undefined" ||
                this.setting.show_today_order_count == undefined
              ) {
                this.setting.show_today_order_count = 0;
              }
              if ( 
                this.setting.today_order_count_time_from == null ||
                typeof this.setting.today_order_count_time_from == "undefined" ||
                this.setting.today_order_count_time_from == undefined
              ) {
                this.setting.today_order_count_time_from = "00:00";
              }
            } else {
              this.setting = {
                template_id: 4,
                order_for_collect: 0,
                open_hot_block_1: 0,
                hot_block_title_1: 0,
                hot_product_list_1: [],
                open_topics_block_1: 0,
                open_best_sale_block_1: 0,
                open_category_block_2: 0,
                show_announcement_4: 0,
                show_explanation_4: 0,
                show_rule_4: 0,
                open_hot_block_4: 0,
                share_register_4: 0,
                hot_block_title_4: "",
                hot_food_title_4: "",
                hot_food_title_3: "",
                hot_product_list_4: [],
                hot_food_list_4: [],
                hot_food_list_3: [],
                city_enable: 0,
                is_hidden_regiest: 0,
                show_today_order_count: 0,
                today_order_count_time_from: "00:00",
              };
            }
          }
        }.bind(this)
      );
    },
    async save() {
      this.$store.dispatch("fullscreenLoading");

      // 暂时关闭展示热门商品
      this.setting.hot_material_enable = 0;
      this.setting.hot_material_title = "";
      this.hot_material_img = "";
      this.hot_material_img_file = null;

      this.$refs.observer.validate().then(
        async function (result) {
          if (result) {
            let setting = {};
            if (this.template_id == 3) {
              // 城市模板
              var city_template_ids = [];
              if (this.city_template_id.length) {
                this.city_template_id.forEach((city) => {
                  if (city.city_name && city.template) {
                    city_template_ids.push({
                      city_name: city.city_name,
                      template_id: city.template.id,
                    });
                  }
                });
              } else {
                city_template_ids = [];
              }

              // 专题模块
              var special_list = [];
              var special_null_num = null;
              for (let i = 0; i < this.special_list.length; i++) {
                var img = "";
                if (this.special_list[i].log_image_file) {
                  let response = await Files.imageUpload(
                    this.special_list[i].log_image_file,
                    false,
                    "wechat"
                  );
                  if (response.data.status.isOK()) {
                    img = response.data.data.img_name;
                  }
                } else {
                  if (this.special_list[i].logo) {
                    img = this.special_list[i].logo;
                  } else {
                    img = "";
                  }
                }
                special_list.push({
                  title: this.special_list[i].title,
                  logo: img,
                  production_list: this.special_list[i].production.map(
                    (production) => {
                      return production.id;
                    }
                  ),
                });
                if (
                  !this.special_list[i].log_image ||
                  !this.special_list[i].production.length
                ) {
                  special_null_num += 1;
                }
              }
              // 热门商品
              var hotImg = "";
              if (this.hot_material_img_file) {
                let response = await Files.imageUpload(
                  this.hot_material_img_file,
                  false,
                  "wechat"
                );
                if (response.data.status.isOK()) {
                  hotImg = response.data.data.img_name;
                }
              } else {
                if (this.templateThreeSettings.hot_material_img_url) {
                  hotImg = this.templateThreeSettings.hot_material_img;
                } else {
                  hotImg = "";
                }
              }
              var hot_material_list = this.hotMaterial.map((material) => {
                return material.id;
              });

              // 暂时关闭展示热门商品
              hotImg = "";
              hot_material_list = "";

              // 温馨提示图片
              var notifyImg = "";
              if (this.notify_img_file) {
                let response = await Files.imageUpload(
                  this.notify_img_file,
                  false,
                  "wechat"
                );
                if (response.data.status.isOK()) {
                  notifyImg = response.data.data.img_name;
                }
              } else {
                if (this.templateThreeSettings.notify_img_url) {
                  notifyImg = this.templateThreeSettings.notify_img;
                } else {
                  notifyImg = "";
                }
              }

              // 主题图
              var themeImg = "";
              if (this.theme_img_file) {
                let response = await Files.imageUpload(
                  this.theme_img_file,
                  false,
                  "wechat"
                );
                if (response.data.status.isOK()) {
                  themeImg = response.data.data.img_name;
                }
              } else {
                if (this.templateThreeSettings.theme_img_url) {
                  themeImg = this.templateThreeSettings.theme_img;
                } else {
                  themeImg = "";
                }
              }

              // 热门分类
              var hot_category_list = this.hotCategories.map((category) => {
                return category.id;
              });

              // 首页推荐展示
              var top_recommend_category_list = this.homeCategories.map(
                (category) => {
                  return category.id;
                }
              );
              // 单品推广
              var material_banner_list = [];
              var material_null_num = null;
              if (this.bannerMaterial.length) {
                for (let i = 0; i < this.bannerMaterial.length; i++) {
                  var bannerimg = "";
                  if (this.bannerMaterial[i].banner_img_file) {
                    let response = await Files.imageUpload(
                      this.bannerMaterial[i].banner_img_file,
                      false,
                      "wechat"
                    );
                    if (response.data.status.isOK()) {
                      bannerimg = response.data.data.img_name;
                    }
                  } else {
                    if (this.bannerMaterial[i].img) {
                      bannerimg = this.bannerMaterial[i].img;
                    } else {
                      bannerimg = "";
                    }
                  }
                  if (!this.bannerMaterial[i].banner_img) {
                    material_null_num += 1;
                  }
                  material_banner_list.push({
                    img: bannerimg,
                    material_id: this.bannerMaterial[i].id,
                  });
                }
              } else {
                material_null_num += 1;
              }

              setting = Object.assign({}, this.setting, {
                template_id: this.template_id,
                city_template_id: city_template_ids,
                special_list: special_list,
                hot_material_list: hot_material_list,
                hot_material_img: hotImg,
                notify_img: notifyImg,
                theme_img: themeImg,
                hot_category_list: hot_category_list,
                top_recommend_category_list: top_recommend_category_list,
                material_banner_list: material_banner_list,
              });
            } else {
              setting = Object.assign({}, this.setting, {
                hot_product_list_1: this.materialIdsArr_1,
                hot_product_list_4: this.materialIdsArr_4,
                hot_food_list_4: this.foodIdsArr_4,
                hot_food_list_3: this.foodIdsArr_3,
                template_id: this.template_id,
              });
            }

            if (this.template_id == 3) {
              if (special_null_num && this.setting.special_enable) {
                this.$store.dispatch("fullscreenLoadingStop");
                this.$snackbar.error(
                  i18n.t("MiniProgramSettings.nullHint.special_null_num")
                );
              } else if (
                material_null_num &&
                this.setting.material_banner_enable
              ) {
                this.$store.dispatch("fullscreenLoadingStop");
                this.$snackbar.error(
                  i18n.t("MiniProgramSettings.nullHint.material_null_num")
                );
              } else if (
                !this.hot_material_img &&
                this.setting.hot_material_enable
              ) {
                this.$store.dispatch("fullscreenLoadingStop");
                this.$snackbar.error(
                  i18n.t("MiniProgramSettings.nullHint.hot_material_img")
                );
              } else if (
                !this.hotMaterial.length &&
                this.setting.hot_material_enable
              ) {
                this.$store.dispatch("fullscreenLoadingStop");
                this.$snackbar.error(
                  i18n.t("MiniProgramSettings.nullHint.hotMaterial")
                );
              } else if (
                !this.hotCategories.length &&
                this.setting.hot_category_enable
              ) {
                this.$store.dispatch("fullscreenLoadingStop");
                this.$snackbar.error(
                  i18n.t("MiniProgramSettings.nullHint.hotCategories")
                );
              } else if (
                this.setting.hot_category_enable &&
                this.hotCategories.length != 4 // 首页展示热门分类数量限制
              ) {
                this.$store.dispatch("fullscreenLoadingStop");
                this.$snackbar.error(
                  i18n.t("MiniProgramSettings.nullHint.hotCategoriesMax", [
                    this.hotCategories.length,
                  ])
                );
              } else if (!this.notify_img && this.setting.notify_img_enable) {
                this.$store.dispatch("fullscreenLoadingStop");
                this.$snackbar.error(
                  i18n.t("MiniProgramSettings.nullHint.notify_img")
                );
              } else {
                Settings.batchSave([
                  {
                    setting_key: "miniprogram",
                    setting_value: setting,
                  },
                ]).then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.$snackbar.success(
                        i18n.t("BusinessSetting.saveSuccess")
                      );
                      // this.getSettingsFromAPI();
                    }
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                );
              }
            } else {
              Settings.batchSave([
                {
                  setting_key: "miniprogram",
                  setting_value: setting,
                },
              ]).then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.$snackbar.success(
                      i18n.t("BusinessSetting.saveSuccess")
                    );
                    // this.getSettingsFromAPI();
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
            }
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    syncMaterialShowCategories() {
      MaterialCategories.syncMaterialShowCategories();
    },
    addCity() {
      this.city_template_id.push({ city_name: "", template: null });
    },
    addSpecial() {
      if (this.special_list.length < 4) {
        this.special_list.push({
          log_image: null,
          log_image_file: null,
          production: [],
        });
      }
    },
    async getCategoryListName() {
      if (
        this.templateThreeSettings.top_recommend_category_list &&
        this.templateThreeSettings.top_recommend_category_list.length
      ) {
        this.home_category_enable = 1;
        let response = await MaterialShowCategories.materialShowCategoriesList({
          ids: this.templateThreeSettings.top_recommend_category_list,
        });
        if (response.data.status.isOK()) {
          this.homeCategories = response.data.show_categories;
          if (
            this.templateThreeSettings.hot_category_list &&
            this.templateThreeSettings.hot_category_list.length
          ) {
            MaterialShowCategories.materialShowCategoriesList({
              ids: this.templateThreeSettings.hot_category_list,
            }).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.hotCategories = response.data.show_categories;
                }
              }.bind(this)
            );
          }
        }
      } else if (
        this.templateThreeSettings.hot_category_list &&
        this.templateThreeSettings.hot_category_list.length
      ) {
        this.home_category_enable = 0;
        let response = await MaterialShowCategories.materialShowCategoriesList({
          ids: this.templateThreeSettings.hot_category_list,
        });
        if (response.data.status.isOK()) {
          this.hotCategories = response.data.show_categories;
        }
      }
    },
  },

  watch: {
    setting: {
      deep: true,
      handler() {
        if (this.template_id) {
          this.template = this.homeTemplates.find(
            (home_template) => home_template.value == this.template_id
          );
        } else {
          this.template = { value: 4 };
        }
        if (!this.setting.city_enable) {
          this.city_template_id = [];
        } else {
          if (!this.city_template_id.length) {
            this.city_template_id = [{}];
          }
        }

        if (!this.setting.special_enable) {
          this.special_list = [];
        } else {
          if (!this.special_list.length) {
            this.special_list = [
              { log_image: null, log_image_file: null, production: [] },
            ];
          }
        }

        if (!this.setting.material_banner_enable) {
          this.bannerMaterial = [];
        }

        // 暂时关闭展示热门商品
        // if (!this.setting.hot_material_enable) {
        //   this.setting.hot_material_title = "";
        //   this.hot_material_img = "";
        //   this.hot_material_img_file = null;
        // }

        if (!this.setting.hot_category_enable) {
          this.hotCategories = [];
        }

        if (!this.setting.notify_img_enable) {
          this.notify_img = "";
          this.notify_img_file = null;
        }
      },
    },
    home_category_enable: {
      handler() {
        if (!this.home_category_enable) {
          this.homeCategories = [];
        }
      },
    },
    templateThreeSettings: {
      handler() {
        if (!this.setting.city_enable) {
          this.city_template_id = [];
        } else {
          if (!this.templateThreeSettings.city_template_id.length) {
            this.city_template_id = [{}];
          } else {
            this.city_template_id =
              this.templateThreeSettings.city_template_id.map((city) => {
                return {
                  template: { id: city.template_id },
                  city_name: city.city_name,
                  template_id: city.template_id,
                };
              });
          }
        }

        //专题模块
        if (
          this.templateThreeSettings.special_list &&
          this.templateThreeSettings.special_list.length
        ) {
          this.special_list = this.templateThreeSettings.special_list;
          this.templateThreeSettings.special_list.forEach((material, index) => {
            material.log_image = material.logo ? material.logo_url : "";
            material.log_image_file = null;
            if (material.production_list.length) {
              Materials.fetchNoCancel({
                material_ids: material.production_list,
              }).then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.special_list.splice(
                      index,
                      1,
                      Object.assign({}, material, {
                        production: response.data.materials,
                      })
                    );
                  }
                }.bind(this)
              );
            } else {
              this.special_list.splice(
                index,
                1,
                Object.assign({}, material, {
                  production: [],
                })
              );
            }
          });
        }
        //  首页推广
        if (
          this.templateThreeSettings.material_banner_list &&
          this.templateThreeSettings.material_banner_list.length
        ) {
          this.bannerMaterial = this.templateThreeSettings.material_banner_list;
          this.templateThreeSettings.material_banner_list.forEach(
            (material, index) => {
              material.banner_img = material.img ? material.img_rul : "";
              material.banner_img_file = null;
              // let materialInfo = [];
              Materials.fetchNoCancel({
                material_ids: [material.material_id],
              }).then(
                function (response) {
                  if (response.data.status.isOK()) {
                    // materialInfo = response.data.materials;
                    this.bannerMaterial.splice(
                      index,
                      1,
                      Object.assign({}, material, {
                        material_code: response.data.materials[0].material_code,
                        material_name: response.data.materials[0].material_name,
                        standard_name: response.data.materials[0].standard_name,
                        id: material.material_id,
                      })
                    );
                  }
                }.bind(this)
              );
            }
          );
        }
        // 获取热门商品
        if (
          this.templateThreeSettings.hot_material_list &&
          this.templateThreeSettings.hot_material_list.length
        ) {
          if (this.templateThreeSettings.hot_material_list.length) {
            Materials.fetchNoCancel({
              material_ids: this.templateThreeSettings.hot_material_list,
            }).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.hotMaterial = response.data.materials;
                }
              }.bind(this)
            );
          }
        }
        // 获取热门分类
        this.getCategoryListName();
        // 温馨提示图片
        if (this.templateThreeSettings.notify_img_url)
          this.notify_img = this.templateThreeSettings.notify_img_url;
        // 主题图
        if (this.templateThreeSettings.theme_img_url)
          this.theme_img = this.templateThreeSettings.theme_img_url;
        // 热门商品宣传图片
        if (this.templateThreeSettings.hot_material_img_url)
          this.hot_material_img =
            this.templateThreeSettings.hot_material_img_url;
      },
    },
    materials_1: {
      handler() {
        if (this.materials_1.length) {
          this.materialIdsArr_1 = this.materials_1.map((material) => {
            return material.id;
          });
        } else {
          this.materialIdsArr_1 = [];
        }
      },
    },
    materials_4: {
      handler() {
        if (this.materials_4.length) {
          this.materialIdsArr_4 = this.materials_4.map((material) => {
            return material.id;
          });
        } else {
          this.materialIdsArr_4 = [];
        }
      },
    },
    foods_4: {
      handler() {
        if (this.foods_4.length) {
          this.foodIdsArr_4 = this.foods_4.map((food) => {
            return food.id;
          });
        } else {
          this.foodIdsArr_4 = [];
        }
      },
    },
    foods_3: {
      handler() {
        if (this.foods_3.length) {
          this.foodIdsArr_3 = this.foods_3.map((food) => {
            return food.id;
          });
        } else {
          this.foodIdsArr_3 = [];
        }
      },
    },
    addMaterials: {
      handler() {
        if (this.template_id == 1) {
          this.addMaterials.map((add) => {
            if (
              !this.materials_1.find((material_1) => material_1.id == add.id)
            ) {
              this.materials_1.push(add);
            }
          });
        } else if (this.template_id == 4) {
          this.addMaterials.map((add) => {
            if (
              !this.materials_4.find((material_4) => material_4.id == add.id)
            ) {
              this.materials_4.push(add);
            }
          });
        }
      },
    },
    addFoods: {
      handler() {
        if (this.template_id == 4) {
          this.addFoods.map((add) => {
            if (!this.foods_4.find((food_4) => food_4.id == add.id)) {
              this.foods_4.push(add);
            }
          });
        }
        if (this.template_id == 3) {
          this.addFoods.map((add) => {
            if (!this.foods_3.find((food_3) => food_3.id == add.id)) {
              this.foods_3.push(add);
            }
          });
        }
      },
    },
    addProductions: {
      handler() {
        if (this.specialListIndex == 0) {
          this.addProductions.map((add) => {
            this.special_list[0].production.push(add);
          });
          // this.special_list.splice(
          //   0,
          //   1,
          //   Object.assign({}, this.special_list[0], {
          //     production: this.selectMaterial,
          //   })
          // );
        } else if (this.specialListIndex == 1) {
          this.addProductions.map((add) => {
            this.special_list[1].production.push(add);
          });
        } else if (this.specialListIndex == 2) {
          this.addProductions.map((add) => {
            this.special_list[2].production.push(add);
          });
        } else if (this.specialListIndex == 3) {
          this.addProductions.map((add) => {
            this.special_list[3].production.push(add);
          });
        }
      },
    },
    hot_material_img: {
      handler() {
        if (!this.hot_material_img) {
          this.hot_material_img_file = null;
        }
      },
    },
    hot_material_img_file: {
      handler() {
        if (this.hot_material_img_file) {
          var reader = new FileReader();
          reader.readAsDataURL(this.hot_material_img_file);
          let that = this;
          reader.onload = function () {
            that.hot_material_img = this.result;
          };
        } else {
          this.hot_material_img = this.templateThreeSettings.hot_material_img
            ? this.templateThreeSettings.hot_material_img_url
            : "";
        }
      },
    },
    notify_img: {
      handler() {
        if (!this.notify_img) {
          this.notify_img_file = null;
        }
      },
    },
    notify_img_file: {
      handler() {
        if (this.notify_img_file) {
          var reader = new FileReader();
          reader.readAsDataURL(this.notify_img_file);
          let that = this;
          reader.onload = function () {
            that.notify_img = this.result;
          };
        } else {
          this.notify_img = this.templateThreeSettings.notify_img
            ? this.templateThreeSettings.notify_img_url
            : "";
        }
      },
    },
    theme_img: {
      handler() {
        if (!this.theme_img) {
          this.theme_img_file = null;
        }
      },
    },
    theme_img_file: {
      handler() {
        if (this.theme_img_file) {
          var reader = new FileReader();
          reader.readAsDataURL(this.theme_img_file);
          let that = this;
          reader.onload = function () {
            that.theme_img = this.result;
          };
        } else {
          this.theme_img = this.templateThreeSettings.theme_img
            ? this.templateThreeSettings.theme_img_url
            : "";
        }
      },
    },
    special_list: {
      deep: true,
      handler() {
        this.special_list.forEach((special, index) => {
          if (special.log_image_file) {
            var reader = new FileReader();
            reader.readAsDataURL(special.log_image_file);
            reader.onload = function () {
              special.log_image = this.result;
            };
          } else {
            special.log_image = special.logo ? special.logo_url : "";
          }
          if (index == 0) {
            if (special.production && special.production.length) {
              this.specialMaterialIdsArr_1 = special.production.map(
                (material) => {
                  return material.id;
                }
              );
            } else {
              this.specialMaterialIdsArr_1 = [];
            }
          } else if (index == 1) {
            if (special.production && special.production.length) {
              this.specialMaterialIdsArr_2 = special.production.map(
                (material) => {
                  return material.id;
                }
              );
            } else {
              this.specialMaterialIdsArr_2 = [];
            }
          } else if (special.production && index == 2) {
            if (special.production.length) {
              this.specialMaterialIdsArr_3 = special.production.map(
                (material) => {
                  return material.id;
                }
              );
            } else {
              this.specialMaterialIdsArr_3 = [];
            }
          } else if (special.production && index == 3) {
            if (special.production.length) {
              this.specialMaterialIdsArr_4 = special.production.map(
                (material) => {
                  return material.id;
                }
              );
            } else {
              this.specialMaterialIdsArr_4 = [];
            }
          }
        });
      },
    },
    addBannerMaterials: {
      handler() {
        if (this.addBannerMaterials.length + this.bannerMaterial.length > 10) {
          this.$snackbar.error(
            i18n.t("MiniProgramSettings.Fields.material_banner_list_hint")
          );
        } else {
          this.addBannerMaterials.map((add) => {
            if (
              !this.bannerMaterial.find((material_1) => material_1.id == add.id)
            ) {
              this.bannerMaterial.push(
                Object.assign({}, add, {
                  banner_img_file: null,
                  banner_img: "",
                })
              );
            }
          });
        }
      },
    },
    bannerMaterial: {
      deep: true,
      handler() {
        if (this.bannerMaterial.length) {
          this.bannerMaterial.forEach((banner) => {
            if (banner.banner_img_file) {
              var reader = new FileReader();
              reader.readAsDataURL(banner.banner_img_file);
              reader.onload = function () {
                banner.banner_img = this.result;
              };
            } else {
              banner.banner_img = banner.img ? banner.img_rul : "";
            }
          });
          this.bannerMaterialIdsArr = this.bannerMaterial.map((material) => {
            return material.id;
          });
        } else {
          this.bannerMaterialIdsArr = [];
        }
      },
    },
    addhotMaterials: {
      handler() {
        if (this.addhotMaterials.length + this.hotMaterial.length > 20) {
          this.$snackbar.error(
            i18n.t("MiniProgramSettings.Fields.hot_material_list_hint")
          );
        } else {
          this.addhotMaterials.map((add) => {
            if (
              !this.hotMaterial.find((material_1) => material_1.id == add.id)
            ) {
              this.hotMaterial.push(add);
            }
          });
        }
      },
    },
    hotMaterial: {
      handler() {
        if (this.hotMaterial.length) {
          this.hotMaterialIdsArr = this.hotMaterial.map((material) => {
            return material.id;
          });
        } else {
          this.hotMaterialIdsArr = [];
        }
      },
    },
    addhotCategories: {
      handler() {
        this.addhotCategories.map((add) => {
          if (
            !this.hotCategories.find((material_1) => material_1.id == add.id)
          ) {
            this.hotCategories.push(add);
          }
        });
      },
    },
    addHomeCategories: {
      handler() {
        this.addHomeCategories.map((add) => {
          if (
            !this.homeCategories.find((material_1) => material_1.id == add.id)
          ) {
            this.homeCategories.push(add);
          }
        });
      },
    },
    hotCategories: {
      handler() {
        if (this.hotCategories.length) {
          this.hotCategoryIdsArr = this.hotCategories.map((category) => {
            return category.id;
          });
        } else {
          this.hotCategoryIdsArr = [];
        }
      },
    },
    homeCategories: {
      handler() {
        if (this.homeCategories.length) {
          this.homeCategoryIdsArr = this.homeCategories.map((category) => {
            return category.id;
          });
        } else {
          this.homeCategoryIdsArr = [];
        }
      },
    },
    template_id: {
      handler() {
        if (this.template_id) {
          this.template = this.homeTemplates.find(
            (home_template) => home_template.value == this.template_id
          );
        } else {
          this.template = { value: 4 };
        }
        if (this.template_id == 3) {
          this.setting = Object.assign({}, this.setting, {
            city_enable: this.setting.city_enable
              ? this.setting.city_enable
              : 0,
            special_enable: this.setting.special_enable
              ? this.setting.special_enable
              : 0,
            announcement_enable:
              this.setting.announcement_enable != null &&
              typeof this.setting.announcement_enable != "undefined" &&
              this.setting.announcement_enable != undefined
                ? this.setting.announcement_enable
                : 1,
            material_banner_enable: this.setting.material_banner_enable
              ? this.setting.material_banner_enable
              : 0,
            // 暂时关闭展示热门商品
            // hot_material_enable: this.setting.hot_material_enable
            //   ? this.setting.hot_material_enable
            //   : 0,
            hot_material_enable: 0,

            hot_category_enable: this.setting.hot_category_enable
              ? this.setting.hot_category_enable
              : 0,
            notify_img_enable: this.setting.notify_img_enable
              ? this.setting.notify_img_enable
              : 0,
          });
        }
      },
    },
  },
};
</script>